import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { ConfigService } from '../../config';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {

	apiName: string;

	constructor(private configService: ConfigService) {
		this.apiName = this.configService.get('host');
	}

	authConfirmed(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/auth-confirmed';
			const params = {
				body: {}
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
